import styled from 'styled-components';
import * as Comp from './components/CheckboxCard';

export const CheckboxCard = styled(Comp.CheckboxCard)``;
export interface CheckboxCardProps extends Comp.CheckboxCardProps {}
